import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { StockComponent } from '../pages/stock/stock.component';
import { ReservationsComponent } from '../pages/reservations/reservations.component';
import { ReservationsAddComponent } from '../pages/reservations-add/reservations-add.component';
import { OrderComponent } from '../pages/order/order.component';
import { OrderAddComponent } from '../pages/order-add/order-add.component';

import { AppRoutingModule } from '../app-routing.module';

@NgModule({
  declarations: [LayoutComponent, HeaderComponent, StockComponent, ReservationsComponent, ReservationsAddComponent, OrderComponent, OrderAddComponent],
  exports: [LayoutComponent],
  imports: [AppRoutingModule, BrowserModule, CommonModule, FormsModule]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/layout/layout.module.ts